export interface UploadDetails {
  id: string;
  file: File;
}

export interface UploadsResponse {
  documents: UploadDetails;
  residence_proof: UploadDetails;
  income_proof: UploadDetails;
}

export interface UploadResult {
  success: boolean;
  documentType: string;
  response?: any;
}

export const transformUploadsToResponse = (uploadResult: any, data: any): UploadsResponse => {
  const response: UploadsResponse = {
    documents: {
      id: uploadResult?.documents?.id || uploadResult?.document_id || '',
      file: data.documentoIdentificacao as File
    },
    residence_proof: {
      id: uploadResult?.residence_proof?.id || uploadResult?.residence_proof_id || '',
      file: data.comprovanteResidencia as File
    },
    income_proof: {
      id: uploadResult?.income_proof?.id || uploadResult?.income_proof_id || '',
      file: data.comprovanteRenda as File
    },
  };

  return response;
};
